var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('img',{staticStyle:{"width":"375px"},attrs:{"src":"http://cdn2024.shiwuzone.com/routuan/image/iphoneX-navigation.png","alt":""}}),_c('div',{staticClass:"titlebox"},[_c('div',{staticClass:"content ellipsis"},[_vm._v(_vm._s(_vm.editmsg.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }